<script lang="ts">
    import { Col } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
    import { Blockquotes, BlockquotesMessage } from "../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card cardHeader2props="pb-0">
      <div slot="customHeader2">
        <h5>{Blockquotes}</h5>
        <span>{@html BlockquotesMessage}</span>
      </div>
      <div slot="contentbody">
        {#each data.Blockquotes as fontItem}
          <p class="sub-title">{fontItem.title}</p>
          <div class="figure d-block {fontItem.class}">
            <blockquote class="blockquote">
              <p class="mb-0">{fontItem.discription}</p>
            </blockquote>
            <div class="blockquote-footer">{fontItem.footer1} 
              <cite title="Source Title">{fontItem.footer2}</cite>
            </div>
          </div>
        {/each}
      </div>
    </Card>
</Col>